module.exports = __webpack_public_path__ + "static/media/LuBros Logo.1c1e5a8a.png";